import React from 'react';
import { withRouter } from 'react-router-dom';
import { TableRow, TableCell } from '@material-ui/core';
const TaskStatusList = ({item}) => {
  return(
    <TableRow hover tabIndex={-1}>
        <TableCell>{item.user && item.user.name ? item.user.name : '--'}</TableCell>
        <TableCell>{item.total_count}</TableCell>
        <TableCell>{item.open}</TableCell>
        <TableCell>{item.reopened}</TableCell>
        <TableCell>{item.closed}</TableCell>
    </TableRow>
  )
}
export default TaskStatusList;
